import $ from 'jquery'; 

function recipeJS(){
   //console.log('recipe code');
   // Nutritional facts
   let titleHeight = $('.nutritional_facts__title').innerHeight();
   $('.nutritional_facts__title i').css({
      'height' : (titleHeight * 3/4),
      'top' : ((titleHeight * 3/4) / 6),
      'right' : -(titleHeight * 5/4)
   });
   $('.nutritional_facts__header').on('click',function(){
     // console.log('clicked y');
      $(this).toggleClass('nutritional_facts__header--collapse');
   });
   ///Ingredients
   // $('#ingredients ul > li').each(function(index) {
   //    $(this).attr({
   //       'data-aos':"fade-up",
   //       'data-aos-once':'true',
   //       'data-aos-delay':100*index,
   //       'data-aos-offset':-($(this).outerHeight()/2)*index,
   //    });
   // });

   ///Print Button
   $('#print-button').on('click',function(){
      $('.nutritional_facts__header').click();
      window.print();
   });
   
   //Remove nutritional facts if empty
   let nut_label = $('#nutritional > table.nutritional_facts__table').html().replace(/\s+/g, '');
   //console.log(nut_label);
   let empty_label = '<thead><tr><thcolspan="3"class="small-info">AmountPerServing</th></tr></thead><tbody><tr><thcolspan="2"><bstyle="vertical-align:text-bottom">Calories</b><spanstyle="font-size:1.5em;margin-left:0.25em;font-weight:bold;"></span></th><td></td></tr><trclass="thick-row"><tdcolspan="3"class="small-info"><b>%DailyValue*</b></td></tr></tbody>';
   if(nut_label == empty_label){
     // console.log('empty');
      $('#nutritional').css('display','none');
   } else{
     // console.log('not empty');
   }
   //AOS.refresh();


   ///Move nutritional facts up 
   function moveNutrition() {
      $('#nutritional').css('transform', '');
      let ingredTop = $('#ingredients').offset().top + $('#ingredients').outerHeight();
      let nutriBot = $('#nutritional').offset().top;
      let adjust = ingredTop - nutriBot;
    
      $('#nutritional').css('transform', 'translateY(calc(' + adjust + 'px + 2em))');
    }
    
    $(window).resize(function() {
      moveNutrition();
    });
    moveNutrition();
    
   //Fix any large whitespace gaps between ingredients, tips and variations
   function fixWhiteSpace(){
      const ingredients = $('#ingredients');
      const instructions = $('#instructions');
      const tips = $('#tips');
      const variations = $('#variations');
      let instruct_trueHeight = 0;
      instructions.children().each(function() {
         instruct_trueHeight += $(this).height();
      });
      let ingred_trueHeight = 0;
      instructions.children().each(function() {
         ingred_trueHeight += $(this).height();
      });
      if(instructions.height() >= (instruct_trueHeight + (tips.height()*0.90)) && tips.height() !== 0 && variations.height() < tips.height()){
          // If tips can fit inside instructions without being bigger than ingredients, do it.
          console.log('case 1');
         tips.detach();
         tips.appendTo(instructions);
      } else if(instructions.height() >= (instruct_trueHeight + (variations.height()*0.90)) && variations.height() !== 0 && variations.height() > tips.height()){
          // If variations can fit inside instructions without being bigger than ingredients, do it.
          console.log('case 2');
         variations.detach();
         variations.appendTo(instructions);
         tips.css({'grid-area' : '4/2/5/3'});
         tips.children('h2').css({
            'margin-top' : '0'
         })
      } else if((instruct_trueHeight / 2) >= ingred_trueHeight){
         // If instructions are twice the size of ingredients, split variations and tips between the two rows
         console.log('case 3');
         variations.css({'grid-area' : '4/1/4/2'});
         tips.css({'grid-area' : '4/2/4/3'});
      }
   }
   fixWhiteSpace();


   return (null)
}
export default recipeJS